/**
 * Get a `path` within the `json` and returns a default value if path does not exists.
 *
 * e.g.: `get('a.b.c', obj)` is equivalent to `obj.a.b.c`
 *
 * @param {String} path The path within `json`
 * @param {Object.<string,any>} json The object to be queried
 * @param {any=undefined} def An default to return if value is not existant
 * @returns {any} `json` value at key in `path`
 */
export default (path, json, def = undefined) => path.split('.')
  .reduce((val, next) => val ? val[next] ?? def : def, json);
